/*
    ** Wrapper table
*/
let width = document.body.clientWidth;

if (document.querySelectorAll('.textimg table').length > 0) {
    let tbls = document.querySelectorAll('.textimg table');
    for (const tbl of tbls) {
        let parent = tbl.parentNode;
        let wrapper = document.createElement('div');
        if (width > 578) {
            wrapper.style.overflowX = "auto";

        }
        wrapper.classList.add('wrapper-table');
        wrapper.classList.add('br-5');
        parent.insertBefore(wrapper, tbl);
        wrapper.appendChild(tbl);
    }
}